import React from "react";
import GlobalStyle from "../styles/GlobalStyle";
// components
import HeroSection from "../sections/Home/HeroSection"
import Solutions from "../sections/Home/Solutions"
import Integrate from "../sections/Home/Integrate"
import Experiences from "../sections/Home/Experiences"
import Pricing from "../sections/Home/Pricing"
import VerifyUi from "../sections/Home/VerifyUi"
import Demo from "../sections/Home/Demo"
import Form from "../sections/Home/Form"
import Footer from "../components/Footer"
import Navbar from "../components/Navbar"
import Seo from "../components/Seo"
import HubspotForm from "../components/HubspotForm"


export default function IndexPage() {
	return (
		<>
			<Seo />
			<GlobalStyle />
			<Navbar />
			<HeroSection />
			<Solutions />
			<Integrate />
			<Experiences />
			<VerifyUi />
			<Pricing />
			<Demo />
			<Form />
			<Footer />
		</>
	);
}
